import { communityService } from '../../services';

const addOrderKeysToCommunities = async () => {
  const result = await communityService.buildKeys();

  if (result.isLeft()) {
    const error = result.value;
    throw new Error(error.message);
  } else {
    return result.value.getValue();
  }
};

export default addOrderKeysToCommunities;
